import {
  CREATE_CONVERSATION_ROUTE,
  DELETE_CONVERSATION_ROUTE,
  GET_CONVERSATION_ITEMS_ROUTE,
  GET_CONVERSATION_ROUTE,
} from '../../handlers/conversations';

export const CONVERSATIONS_ROUTES = [
  CREATE_CONVERSATION_ROUTE,
  GET_CONVERSATION_ROUTE,
  GET_CONVERSATION_ITEMS_ROUTE,
  DELETE_CONVERSATION_ROUTE,
] as const;
